import { Facebook, Instagram, Youtube } from "lucide-react";
import {
  CONTACT,
  NAV_LINKS,
  LINKS,
  IMPRESSUM,
  FOOTER_DOMAIN_NOTE,
} from "../data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-night text-cream">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img src="/assets/logo.png" alt="Comfort Line Bútoráruház logó" className="h-9 w-auto rounded-lg bg-cream p-1" />
            <span className="rounded-full bg-burgundy px-3 py-1 text-xs font-bold uppercase tracking-wider text-white">
              Keszthely
            </span>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-cream/70">
            {CONTACT.tagline} – 2 szinten, 1500 m²-es áruházunkban várunk. A Comfort Line
            Bútoráruházak 2007 óta működő, 100%-ban hazai tulajdonú vállalkozás – első
            áruházunk és székhelyünk Keszthelyen található.
          </p>
          <div className="mt-6 flex gap-3">
            <a href={LINKS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-cream/80 transition-colors hover:border-gold hover:text-gold">
              <Facebook className="h-4 w-4" />
            </a>
            <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-cream/80 transition-colors hover:border-gold hover:text-gold">
              <Instagram className="h-4 w-4" />
            </a>
            <a href={LINKS.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube" data-testid="footer-youtube" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-cream/80 transition-colors hover:border-gold hover:text-gold">
              <Youtube className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-gold">Oldaltérkép</h3>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} data-testid={`footer-nav-${l.href.slice(1)}`} className="text-sm text-cream/75 transition-colors hover:text-gold">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
          <h3 className="mt-8 text-xs font-bold uppercase tracking-[0.22em] text-gold">Áruházaink</h3>
          <p className="mt-4 text-sm text-cream/75" data-testid="footer-stores">
            Keszthely · Nagykanizsa · Veszprém
          </p>
        </div>

        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-gold">Kapcsolat</h3>
          <ul className="mt-5 space-y-2 text-sm text-cream/75">
            <li>{CONTACT.address}</li>
            <li>
              <a href={CONTACT.phoneHref} data-testid="footer-phone" className="hover:text-gold">{CONTACT.phone}</a>
              {" · "}
              <a href={CONTACT.centralPhoneHref} data-testid="footer-central-phone" className="hover:text-gold">{CONTACT.centralPhone}</a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="hover:text-gold">{CONTACT.email}</a>
            </li>
          </ul>

          <div data-testid="impressum-box" className="mt-7 rounded-3xl border border-white/10 bg-white/5 p-6">
            <h3 className="text-xs font-bold uppercase tracking-[0.22em] text-gold">Impresszum</h3>
            <ul className="mt-4 space-y-1.5 text-xs leading-relaxed text-cream/70">
              <li className="font-bold text-cream">{IMPRESSUM.company}</li>
              <li>Székhely: {IMPRESSUM.seat}</li>
              <li>Adószám: {IMPRESSUM.tax}</li>
              <li>Képviselő: {IMPRESSUM.representative}</li>
              <li>Központi telefon: {IMPRESSUM.phone}</li>
              <li>E-mail: {IMPRESSUM.email}</li>
              <li>Tárhely: {IMPRESSUM.hosting}</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="mt-14 border-t border-white/10 pt-8">
        <p className="text-center text-xs leading-relaxed text-cream/50 md:text-left" data-testid="footer-domain-note">
          © 2026 {IMPRESSUM.company} – Comfort Line Bútoráruház, Keszthely. {FOOTER_DOMAIN_NOTE}{" "}
          Fő domainünk – kínálat, katalógusok, referenciák:{" "}
          <a
            href={LINKS.mainSite}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-main-domain-link"
            className="font-semibold text-cream/70 underline-offset-4 hover:text-gold hover:underline"
          >
            comfortbutor.hu
          </a>
        </p>
      </div>
    </div>
  </footer>
);
